module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_400_Medium.c0a540a.woff";